// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1hY-M","emails":"CreateEditClinics_emails__1-ouy","emailTagLabel":"CreateEditClinics_emailTagLabel__229n9"};